import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import AccessDeniedPage from '../pages/AccessDeniedPage'
import { canAccessPath, isRoleAllowedForPath } from './access'
import { PageLoader } from './PageLoader'

export function RequireAccess({ children }: { children: ReactNode }) {
  const location = useLocation()
  const user = useAuthStore((state) => state.user)
  const permissionsLoaded = useAuthStore(
    (state) => state.permissionsLoaded || Array.isArray(state.user?.permissions),
  )

  if (!permissionsLoaded) return <PageLoader />

  const permissions = user?.permissions ?? []
  if (
    !canAccessPath(location.pathname, permissions)
    || !isRoleAllowedForPath(location.pathname, user?.role)
  ) return <AccessDeniedPage />

  return <>{children}</>
}

export default RequireAccess
